import {timeFormat} from 'd3-time-format';

const dimensionMax = 100;
function _dimensionType(dimension) {
  if (typeof dimension === 'string') {
    return {field: dimension, order: 'natural', max: dimensionMax};
  } else if (typeof dimension === 'object') {
    if (!dimension.max) dimension.max = dimensionMax;
    if (!dimension.order) dimension.order = 'natural';
    if (dimension.format && typeof dimension.format === 'string') dimension.format = timeFormat(dimension.format);
    return dimension;
  }
}

export default _dimensionType;


// WEBPACK FOOTER //
// ./layouts/default/_dimensionType.js